import { analyzeCheckoutData, closeCheckoutOverlay } from '@sloyd/pay';
import { toast } from '@sloyd/ui';
import { delay } from 'saga-ts';
import { invokeEvent } from 'shared-base';

const DELAY = 4000;

export function* onPurchaseCompleted(data: PaddleCheckoutData) {
  try {
    const productId = analyzeCheckoutData(data);
    closeCheckoutOverlay();

    if (!productId) {
      throw new Error('Product id not found');
    }

    // NOTE(Rok Kos): Partnero integration per this spec: https://developers.partnero.com/guide/signup-tracking.html
    // @ts-ignore
    po('integration', 'universal', null);

    switch (productId) {
      case 'CREDITS_10':
        toast.show('credits added');
        break;
      case 'MONTH_BASIC':
        invokeEvent('nav', { path: '/celebration/basic' });
        break;
      case 'MONTH_POPULAR':
        invokeEvent('nav', { path: '/celebration/popular' });
        break;
    }

    yield delay(DELAY);

    invokeEvent('REFRESH_USER');
  } catch (err) {
    invokeEvent('sentry', { err });
  }
}
